import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface ConsumerGroupRequestsTableProps {
    consumerGroups: any[];
    resourceStatuses: any[];
}

const ConsumerGroupRequestsTable: React.FC<ConsumerGroupRequestsTableProps> = ({ consumerGroups, resourceStatuses }) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    const getStatusColor = (status: string) => {
        const lowerStatus = status?.toLowerCase();
        if (["active", "approved"].includes(lowerStatus)) return "#12B76A";
        if (lowerStatus === "rejected") return "#F04438";
        return "#FDB022";
    };

    const getStatusBgColor = (status: string) => {
        const lowerStatus = status?.toLowerCase();
        if (["active", "approved"].includes(lowerStatus)) return "#FFFFFF";
        if (lowerStatus === "rejected") return "#F0443810";
        return "#FDB02210";
    };

    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={3}><Typography fontSize="12px" fontFamily="Gilroy-SemiBold">CONSUMER GROUP NAME</Typography></Grid>
                    <Grid item xs={2.5}><Typography fontSize="12px" fontFamily="Gilroy-SemiBold">OWNER</Typography></Grid>
                    <Grid item xs={2}><Typography fontSize="12px" fontFamily="Gilroy-SemiBold">REQUESTED ON</Typography></Grid>
                    <Grid item xs={2.5}><Typography fontSize="12px" fontFamily="Gilroy-SemiBold">ACTIONED BY / REASON</Typography></Grid>
                    <Grid item xs={2}><Typography fontSize="12px" fontFamily="Gilroy-SemiBold">ACTIONED ON</Typography></Grid>
                </Grid>
            </ListItem>
            {consumerGroups.map((cg: any, index: number) => (
                <ListItem
                    key={cg.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: getStatusBgColor(cg.status),
                        borderRadius: "8px",
                    }}
                    onClick={() => navigate(`/consumer-group/requests/details/${cg.id}`)}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => setCardHoverIndex(null)}
                >
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={3}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                 <RectangleIcon sx={{ color: getStatusColor(cg.status), bgcolor: getStatusColor(cg.status), width: "4px", marginRight: "8px" }} />
                                <Typography fontSize="14px" fontFamily="Gilroy-Medium">{cg.consumerGroupName}</Typography>
                                {["active", "approved"].includes(cg.status) && resourceStatuses?.length > 0 && ( 
                                    <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box>Current Status<br />{resourceStatuses.filter(e => e.resourceId === cg.id).map((e, i) => ( <React.Fragment key={i}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
                                        <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, ml: "4px" }} />
                                    </Tooltip>
                                )}
                            </Box>
                        </Grid>
                        <Grid item xs={2.5}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Avatar 
                                        src={cg.ownerAvatar} // <-- USE the 'src' prop
                                        sx={{ mr: 1, height: 30, width: 30 }}
                                    >
                                        {/* This is now a fallback */}
                                        {cg.ownerName?.charAt(0).toUpperCase()}
                                    </Avatar>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{cg.ownerName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={2}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{cg.createdAt ? moment(cg.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Grid>
                        <Grid item xs={2.5}>
                            {cg.status !== "pending" && (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    {cg.approverName && 
                                        <Avatar 
                                            src={cg.approverAvatar} // <-- USE the 'src' prop
                                            sx={{ mr: 1, height: 30, width: 30 }}
                                        >
                                            {/* This is now a fallback */}
                                            {cg.approverName.charAt(0).toUpperCase()}
                                        </Avatar>
                                    }
                                    {cg.approverName && <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{cg.approverName}</Typography>}
                                    {cg.status === "rejected" && cg.reasonForRejection && (
                                        <Tooltip title={`Reason: ${cg.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                    )}
                                </Box>
                            )}
                        </Grid>
                        <Grid item xs={2}>
                            {cg.status !== "pending" && cg.actionedAt && (
                                <Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(cg.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography>
                            )}
                        </Grid>
                    </Grid>
                </ListItem>
            ))}
        </List>
    );
};

export default ConsumerGroupRequestsTable;